// Copyright (c) 2016 Deere & Company

import {getUser} from './get-user';
import {getUserId} from '../../../shared/services/okta';

export const getUseridAndUser = async () => {

    try {

        const racfId = await getUserId();

        return getUser(racfId);

    } catch (response) {

        return false;

    }

};



// WEBPACK FOOTER //
// ./src/user/shared/repositories/get-userid-and-user.js